// extracted by mini-css-extract-plugin
module.exports = {"grid":"FieldStatistics_grid__3M2Gu","gridContainer":"FieldStatistics_gridContainer__hd36G"};